import { render, staticRenderFns } from "./BrandProfile.vue?vue&type=template&id=dce7a9dc&scoped=true"
import script from "./BrandProfile.vue?vue&type=script&lang=js"
export * from "./BrandProfile.vue?vue&type=script&lang=js"
import style0 from "./BrandProfile.vue?vue&type=style&index=0&id=dce7a9dc&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce7a9dc",
  null
  
)

export default component.exports